export const ADMIN = 'admin';
